import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { KClassImpl3o7kfo8v13fhm as KClassImpl } from '../reflect/js/internal/KClassImpl.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_js(_this__u8e3s4) {
  return (_this__u8e3s4 instanceof KClassImpl() ? _this__u8e3s4 : THROW_CCE()).ye();
}
//region block: exports
export {
  get_js as get_js1ale1wr4fbvs0,
};
//endregion

//# sourceMappingURL=JsClass.mjs.map
